/**
 * Bybit WebSocket Configuration
 *
 * @see https://bybit-exchange.github.io/docs/v5/ws/connect
 */

import type { WsChannelDescriptor, WsTopologyInfo } from '../../lib/types';

export const BYBIT_WS_BASE_URL = 'wss://stream.bybit.com/v5/public/spot';

/**
 * @see https://bybit-exchange.github.io/docs/v5/ws/connect
 */
export const BYBIT_WS_CHANNELS: Record<string, WsChannelDescriptor> = {
  orderbook: {
    channel: 'orderbook',
    topic: 'orderbook.<depth>.<symbol>',
    supportsBatching: true,
    docUrl: 'https://bybit-exchange.github.io/docs/v5/websocket/public/orderbook',
  },
  ticker: {
    channel: 'tickers',
    topic: 'tickers.<symbol>',
    supportsBatching: true,
    docUrl: 'https://bybit-exchange.github.io/docs/v5/websocket/public/ticker',
  },
  trades: {
    channel: 'publicTrade',
    topic: 'publicTrade.<symbol>',
    supportsBatching: true,
    docUrl: 'https://bybit-exchange.github.io/docs/v5/websocket/public/trade',
  },
  klines: {
    channel: 'kline',
    topic: 'kline.<interval>.<symbol>',
    supportsBatching: true,
    docUrl: 'https://bybit-exchange.github.io/docs/v5/websocket/public/kline',
  },
};

export const BYBIT_WS_TOPOLOGY: WsTopologyInfo = {
  baseUrl: BYBIT_WS_BASE_URL,
  singleConnectionPerChannel: false,
  heartbeatIntervalMs: 20_000,
  note: 'Client must send ping every 20 seconds. Multiple topics can be subscribed via a single connection.',
};
